/** Enum for different pages of the Lounge modal */
export enum LoungeModalPages {
  none,
  studentPicker,
  detailsInput,
  shareWithTeachers,
  deleteTeam,
  removeTeacherSelf,
}
